module.exports = __webpack_public_path__ + "img/man_img.6199da29.png";